// extracted by mini-css-extract-plugin
module.exports = {"top-logo":"index_top-logo_obIuR","searchContainer":"index_searchContainer_3mJjT","searchIcon":"index_searchIcon_1g9Jg","searchInput":"index_searchInput_1fhh7"};